const INITIAL_STATE = {
  drawerOpen: false,
  activeSections: {}
};

export default(state = INITIAL_STATE, action) => {
  switch (action.type) {
    case "TOGGLE_DRAWER":
      return {
        ...state,
        drawerOpen: !state.drawerOpen
      };
    case "ACTIVATE_SECTION":
      return {
        ...state,
        activeSections: {
          ...state.activeSections,
          [action.payload.route]: action.payload.active
        }
      };
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/containers/application/redux_reducers.js